import { render, staticRenderFns } from "./charge-view.vue?vue&type=template&id=2d37fedc&scoped=true"
import script from "./charge-view.vue?vue&type=script&lang=js"
export * from "./charge-view.vue?vue&type=script&lang=js"
import style0 from "./charge-view.vue?vue&type=style&index=0&id=2d37fedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37fedc",
  null
  
)

export default component.exports